import { getCookie } from './Cookies.js';
export default function(alertEl) {
    // # Initial data
    let ShowAlert = false;
    let NewAlertContent = false;
    if (alertEl.classList.contains('js-alert-updated--1')) {
        NewAlertContent = true;
    }
    let dismissBtn = alertEl.querySelector('[data-alert-dismiss');
    let announcementSeenCookie = getCookie('announcementSeenCookie')
    //console.log('new:', NewAlertContent)
    // # Check initial cookies
    if (NewAlertContent) {
        // If new content, remove announcementSeenCookie and reset variable, and show banner
        ShowAlert = true;
        document.cookie = 'announcementSeenCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        let announcementSeenCookie = getCookie('announcementSeenCookie')
    } else if (announcementSeenCookie == null || announcementSeenCookie == undefined) {
        // If not, if announcementSeenCookie does not exist, show banner
        ShowAlert = true
    }
    // # Show alert
    if (ShowAlert) {
        alertEl.classList.add('js-alert-visible')
    }

    // # isDismissed
    function isDismissed(status) {
        if (true) {
            //console.log('alert was dismissed')
            document.cookie = 'announcementSeenCookie=true;';
            ShowAlert = false
            alertEl.classList.remove('js-alert-visible')
        }
    }

    // # Handle dismissed
    dismissBtn.addEventListener('click', function () {
        isDismissed(true);
        bodyPadding()
    });
    // # After dismiss fix header padding

    /* Body Padding */
    function bodyPadding() {
        var headerHeight = $('header').outerHeight();
        $('body').css('padding-top', headerHeight);
    }
    bodyPadding();
    $(window).resize(function() {
        bodyPadding();
    });
}